import { useState } from 'react';
import { Plus, MessagesSquare } from 'lucide-react';
import ThreadCard from '../ThreadCard';
import AddChatModal from '../AddChatModal';
import projectService from '../../services/projectService';
import { useParams } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import Loaders from '../Loaders';

const ResearchProjectBlock = () => {
  const { id } = useParams();
  const [addChatOpen, setAddChatOpen] = useState(false);
  const { fetch, refetch } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
    refetch: v.refetch,
  }));

  const { _data, _loading } = projectService.GetProjectSessions(id, fetch);

  return (
    <div className="p-8 lg:p-10">
      {addChatOpen && <AddChatModal onClose={() => setAddChatOpen(false)} refetch={refetch} />}

      <div className="mb-8 border-b border-shell-card-border pb-6">
        {!_loading && (
          <>
            <h1 className="text-3xl font-bold text-white mb-2 font-serif capitalize">{_data?.project_name}</h1>
            <p className="text-muted">{_data?.description}</p>
          </>
        )}
      </div>

      <div className="flex items-center justify-between mb-6 gap-4">
        <h2 className="text-lg font-semibold text-white">Chat Threads</h2>
        <button
          type="button"
          onClick={() => setAddChatOpen(true)}
          className="flex items-center gap-2 bg-primary hover:bg-primary/90 text-black text-sm font-medium px-4 py-2 rounded-lg">
          <Plus className="w-4 h-4" /> Add Chat
        </button>
      </div>

      {_loading ? (
        <Loaders viewLoader />
      ) : _data?.sessions?.length === 0 ? (
        <div className="py-20 rounded-lg bg-shell-card border border-shell-card-border flex flex-col items-center justify-center text-center px-6">
          <MessagesSquare className="w-10 h-10 text-white/20 mb-4" />
          <p className="text-sm text-muted-dim leading-relaxed">
            Start chatting below to start chatting with this project,
            <br /> or use the plus button to add existing chats to this project.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4">
          <ThreadCard threadCardsData={_data?.sessions} refetch={refetch} />
        </div>
      )}
    </div>
  );
};

export default ResearchProjectBlock;
